import React from 'react';
import { Button } from 'common/ui/themes/disona/buttons/Button';
import { S } from './style';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState((state) => ({ ...state, error: error.toString() }));
    console.log(error, info);
  }

  onReload = () => {
    window.localStorage.clear();
    window.location = window.location.origin;
  };

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <S.Container>
          <S.H>
            {typeof error === 'string' ? error : 'Something went wrong'}
          </S.H>
          <Button
            style={{ width: '100px' }}
            theme="red"
            size="big"
            onClick={this.onReload}
          >
            Reload
          </Button>
        </S.Container>
      );
    }

    return children;
  }
}
